import jwtAuthAxios from "../../../services/jwtAuth";
import {createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const verifikasiUjian = createAsyncThunk("userData/verifikasiUjian", async(request) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.post(`v1/verification/cbt`,request);
	return response.data;
});

export const getListStepDaftarUser = createAsyncThunk("userData/getListStepDaftarUser", async(request) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.post(`v1/verification/step/daftar`,request);
	return response.data;
});

export const getVerifikasiDaftarUlangUserBaru = createAsyncThunk("userData/getVerifikasiDaftarUlangUserBaru", async(request) => {
	let token = await localStorage.getItem('auth_token');
	jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	const response = await jwtAuthAxios.post(`v1/verification/step/daftar_ulang`,request);
	return response.data;
});

const initialState = {
	verifikasiUjianData : [],
	listStepDaftarUser : [],
	loading: false,
	verifikasiDaftarUlang : {}
}

const userDataSlice = createSlice({
	name: "userData",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getListStepDaftarUser.pending, (state, action) => {
				state.loading = true
			})
			.addCase(getListStepDaftarUser.fulfilled, (state, action) => {
				state.listStepDaftarUser = action.payload
				state.loading = false
			})
			.addCase(getListStepDaftarUser.rejected, (state, action) => {
				state.loading = false
				state.loading = action.error
			})
		builder
			.addCase(verifikasiUjian.pending, (state, action) => {
				state.loading = true
			})
			.addCase(verifikasiUjian.fulfilled, (state, action) => {
				state.verifikasiUjianData = action.payload
				state.loading = false
			})
			.addCase(verifikasiUjian.rejected, (state, action) => {
				state.loading = false
				state.loading = action.error
			})
		builder
			.addCase(getVerifikasiDaftarUlangUserBaru.pending, (state, action) => {
				state.loading = true
			})
			.addCase(getVerifikasiDaftarUlangUserBaru.fulfilled, (state, action) => {
				state.verifikasiDaftarUlang = action.payload
				state.loading = false
			})
			.addCase(getVerifikasiDaftarUlangUserBaru.rejected, (state, action) => {
				state.loading = false
				state.loading = action.error
			})
		
	}
});

export const userDataSelectors = (state) => state.userData;
export default userDataSlice.reducer;
